import { render, staticRenderFns } from "./BankCardBind.vue?vue&type=template&id=29bbc44f&"
import script from "./BankCardBind.vue?vue&type=script&lang=js&"
export * from "./BankCardBind.vue?vue&type=script&lang=js&"
import style0 from "./BankCardBind.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports